import ItemCourse from './itemCourse'

export default class PayAgreementRequest {
  constructor({value, label, course, currency, id, contragent, legal, data, rc, type}) {
    this._value = value;
    this._label = label;
    this._id = id;
    this._course = course;
    this._currency = currency;

    this._contragent = contragent;
    this._legal = legal;

    this._data = data;
    this._rc = rc;
    this._type = type;
    this._filter = {
      direction: 0,
      contragentType: 0,
      contragent: 0,
      legal: 0,
      currency: 0,
    };
    this._loading = false;
    this.AgreementCourse = new ItemCourse();
  }

  get label() {
    return this._label;
  }

  get id() {
    return this._id;
  }

  get type() {
    return this._type;
  }

  get value() {
    return this._value;
  }

  set value(value) {
    this._value = value;
  }

  get value2() {
    return this._value / this.course;
  }

  set value2(value) {
    this._value = Math.round((value * this.course) * 1000000000000) / 1000000000000;
  }

  get course() {
    return this._course;
  }

  set course(value) {
    this._course = value;
  }

  get currency() {
    return this._currency;
  }

  get filter() {
    return this._filter;
  }

  set filter(value) {
    Object.assign(this._filter, value);
    if (this._filter.currency === this.currency) {
      this.course = 1;
    }
  }

  get debt() {
    let debt = this._filter.direction ? this._data.out : this._data.inp;
    return debt > 0 ? debt : 0;
  }

  set debt(value) {
    if (this._filter.direction) {
      this._data.out = value;
    } else {
      this._data.inp = value;
    }
  }

  get debtPay() {
    if (this.debt <= 0) return 0;
    return Math.round((this.debt * this.course) * 1000000000000) / 1000000000000
  }

  get contragent() {
    return this._contragent;
  }

  get legal() {
    return this._legal;
  }

  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  getCourse(date, usePartnerCourse = false, operatorId) {
    // console.log('usePartnerCourse', usePartnerCourse);
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      if (!usePartnerCourse) {
        self.AgreementCourse
          .getAgency(self.currency, self._filter.currency, date)
          .then(data => {
            this._course = data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            self.loading = false;
          })
      } else {
        self.AgreementCourse
          .getOperator(self.currency, self._filter.currency, operatorId, date)
          .then(data => {
            this._course = data;
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            self.loading = false;
          })
      }
    });
  }

  getAgencyCourse(date) {
    const self = this;
    return new Promise((resolve, reject) => {
      self.loading = true;
      self.AgreementCourse
        .getAgency(self.currency, self._filter.currency, date)
        .then(data => {
          this._course = data;
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          self.loading = false;
        })
    });
  }

  getOperatorCourse() {
    const self = this;
    self.loading = true;
    return new Promise((resolve, reject) => {
      self.AgreementCourse
        .getOperator(self.currency, self._filter.currency, self._contragent)
        .then(data => {
          this._course = data;
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          self.loading = false;
        })
    });
  }

  setFilters(filters) {
    let old = {};
    Object.assign(old, this.filters);
    this.filters = filters;
  };

  static setRequests(data) {
    const requests = [];
    data.PaymentsData.OrdersPayments.forEach((request, i) => {
      const operator = data.PartnerContractorsData.Contragents[i];
      requests.push(new PayAgreementRequest({
        value: 0,
        label: request.RequestCode ? request.RequestCode : request.RequestId,
        course: 1,
        currency: request.CurrencyId,
        id: request.RequestId,
        contragent: request.OperatorId,
        legal: operator.SelectedLegalEntityId,
        type: 3,
        data: {
          inp: Math.round(request.OrderPrice * 1000000000000 - request.OrderDebt * 1000000000000) / 1000000000000,
          out: Math.round(request.OrderDebt * 1000000000000) / 1000000000000,
          course: data.PaymentsData.AgreementCurrencyIsNational ? Math.round((1 / request.CourseToAgreement) * 1000000000000) / 1000000000000 : request.CourseToAgreement,
          currency: data.PaymentsData.ItemCourse,
        },
        rc: false,
      }));
    });
    data.PaymentsData.ClientOrdersPayments.forEach((request, i) => {
      requests.push(new PayAgreementRequest({
        value: 0,
        label: request.RequestCode ? request.RequestCode : request.RequestId,
        course: 1,
        currency: request.CurrencyId,
        id: request.RequestId,
        contragent: request.OperatorId,
        legal: 0,
        type: 1,
        data: {
          inp: Math.round(request.OrderDebt * 1000000000000) / 1000000000000,
          out: Math.round(request.OrderPrice * 1000000000000 - request.OrderDebt * 1000000000000) / 1000000000000,
          course: data.PaymentsData.AgreementCurrencyIsNational ? Math.round((1 / request.CourseToAgreement) * 1000000000000) / 1000000000000 : request.CourseToAgreement,
          currency: data.PaymentsData.ItemCourse,
        },
        rc: false,
      }));
    });
    data.PaymentsData.ReservationCenterOrdersPayments.forEach((request, i) => {
      let inp = Math.round((request.OrderPrice - request.OrderDebt) * 1000000000000) / 1000000000000;
      let out = Math.round((request.OrderDebt) * 1000000000000) / 1000000000000;
      requests.push(new PayAgreementRequest({
        value: 0,
        label: request.RequestCode ? request.RequestCode : request.RequestId,
        course: 1,
        currency: request.CurrencyId,
        id: request.RequestId,
        contragent: request.OperatorId,
        legal: 0,
        type: 7,
        data: {
          inp: data.PaymentsData.IsSubAgent ? inp : out,
          out: data.PaymentsData.IsSubAgent ? out : inp,
          course: data.PaymentsData.AgreementCurrencyIsNational ? Math.round((1 / request.CourseToAgreement) * 1000000000000) / 1000000000000 : request.CourseToAgreement,
          currency: data.PaymentsData.AgreementCourse,
        },
        rc: true,
      }));
    });
    return requests;
  }
}
